import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  DropDownIcon, FirstItem, StyledItemList, Title, Wrapper,
} from '../../../elements/ButtonsList/styles';

const ImpcList = ({
  data, width, onToggle = () => null,
}) => {
  const [show, setShow] = useState(false);
  const [impc, updateImpc] = useState([]);

  const toggleOpen = () => {
    const newData = data.split(',').join('\n');
    const newValue = !show;
    updateImpc(newData);
    setShow(newValue);
    onToggle(newValue);
  };
  const hideMenu = () => {
    onToggle(false);
  };

  return (
    <Wrapper
      width={width}
    >
      <FirstItem className="impcButton" open={show} onClick={toggleOpen} data-testid="buttons-list--open">
        <Title>View all</Title>
        <DropDownIcon>
          <FontAwesomeIcon icon="chevron-down" className="icon" />
        </DropDownIcon>
      </FirstItem>
      {(show) && (
        <StyledItemList onClick={hideMenu}>{impc}</StyledItemList>
      )}
    </Wrapper>
  );
};


ImpcList.propTypes = {
  data: PropTypes.string,
  width: PropTypes.string,
  onToggle: PropTypes.func,
};
export default ImpcList;
